export { StackSortOrder, SortOrder } from '@opengov/data-viz';
export var DEFAULT_CHART_WIDTH = 1200;
export var DEFAULT_CHART_HEIGHT = 360;
export var DEFAULT_Y_AXIS_LABEL_OFFSET = 50;
export var DEFAULT_Y_AXIS_LABEL_SPACING = 8;
export var DEFAULT_CHART_MIN_BANDWIDTH = 30;
export var DEFAULT_LINE_POINT_INNER_RADIUS = 2;
export var DEFAULT_LINE_POINT_OUTER_RADIUS = 3;
export var DEFAULT_LINE_POINT_TARGET_RADIUS = 16;
export var Y_AXIS_LABEL_BUFFER = 20;
export var OG_META_DATA_KEY = 'OG_META_OG';